import { useEffect, useState } from 'react';

import { Alert, Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { FaChevronRight } from 'react-icons/fa6';
import { useHistory } from 'react-router-dom';
import { useApp } from 'common/AppContext';

import { unwrap } from './helpers';

export const OpenRuns = () => {

    const { api } = useApp();
    const history = useHistory();

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        api.get('/api/testrail/projects')
            .then(d => setProjects(unwrap(d, 'projects')))
            .catch(e => setError(e?.err || e?.message || String(e)))
            .finally(() => setLoading(false));

    }, [api]);

    return (

        <Container className="py-4">

            <h3 className="mb-1">
                Open TestRail Runs
            </h3>
            <p className="text-muted">
                Pick a project to see its open runs.
            </p>

            {error && (
                <Alert dismissible onClose={() => setError(null)} variant="danger">
                    {error}
                </Alert>
            )}

            {loading ? (
                <Spinner animation="border" />
            ) : projects.length === 0 ? (
                <Alert variant="light">
                    No TestRail projects available.
                </Alert>
            ) : (
                <Row className="g-3">
                    {projects.map(p => (
                        <Col key={p.id} lg={3} md={4} sm={6}>
                            <Card
                                className="h-100 shadow-sm border-0"
                                onClick={() => history.push(`/testrail/runs/projects/${p.id}`)}
                                role="button"
                                style={{ cursor: 'pointer', transition: 'transform 0.1s ease-out' }}
                            >
                                <Card.Body className="d-flex flex-column">
                                    <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                                        <h5 className="m-0">
                                            {p.name}
                                        </h5>
                                        <FaChevronRight className="text-muted flex-shrink-0 mt-1" />
                                    </div>
                                    <div className="text-muted small">
                                        P
                                        {p.id}
                                        {p.is_completed && (
                                            <span className="ms-2 text-success">
                                                · completed
                                            </span>
                                        )}
                                    </div>
                                    {p.announcement && p.show_announcement && (
                                        <div
                                            style={{
                                                display: '-webkit-box',
                                                overflow: 'hidden',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 3
                                            }}
                                            className="text-muted small mt-2"
                                        >
                                            {p.announcement}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}

        </Container>

    );

};
